module.exports = __webpack_public_path__ + "static/media/delete.0e1a15ed.svg";